import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ManageBillingFallback = () => {
  return (
    <Card className="bg-secondary p-0 gap-0">
      <CardHeader className="px-5 pt-3 pb-1">
        <Skeleton className="h-4 w-48" />
      </CardHeader>
      <CardContent className="p-0 flex-1">
        <Card className="p-0 border-x-0 border-b-0 shadow-none h-full">
          <CardHeader className="pt-6">
            <Skeleton className="h-4 w-72" />
          </CardHeader>
          <CardContent>
            <Skeleton className="h-9 w-32" />
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
